import { JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import { Icon, type IconNameString } from '@videoblocks/design-system';

const baseCls = twMerge(
    // .homepage-hero-product is a set of style rules provided within Builder :facepalm:
    'homepage-hero-product',
    'flex items-center gap-1 text-sm text-white font-bold pr-2',
    'mobile-md:text-base ppro-sm:pr-4 ppro-sm:text-base md:pr-6 md:text-base lg:pr-6 lg:text-base',
    'hover:text-gray-200 transition-colors duration-200 cursor-pointer',
);

interface AISearchOptionProps {
    label: string;
    iconName: IconNameString;
    href?: string;
    onClick?: () => void;
}

export default function AISearchOption({ label, iconName, href, onClick }: AISearchOptionProps): JSX.Element {
    if (href) {
        return (
            <a href={href} className={twMerge(baseCls, 'no-underline')} onClick={onClick}>
                <Icon name={iconName} width={16} height={16} className="[&_path]:fill-white [&_path]:stroke-white" />
                {label}
            </a>
        );
    }

    return (
        <button type="button" onClick={onClick} className={twMerge(baseCls, 'bg-transparent border-0 p-0')}>
            <Icon name={iconName} width={16} height={16} className="[&_path]:fill-white" />
            {label}
        </button>
    );
}
